import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';

import { LoginFacade } from '../../application';

import { LoginFormComponent } from './login-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CardModule,
    RippleModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    MessageModule
  ],
  declarations: [LoginFormComponent],
  providers: [LoginFacade]
})
export class LoginFormPageModule {}
